import { render, staticRenderFns } from "./CapituloOncePage.vue?vue&type=template&id=47c57fcf"
import script from "./CapituloOncePage.js?vue&type=script&lang=js&external"
export * from "./CapituloOncePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports